export const RouteConstants = {
  home: "/",
  services: "/services",
  packages: "/packages",
  portfolio: "/portfolio",
  about: "/about",
  contact: "/contact",
  booking: "/booking",
  paymentSuccess: "/payment/success",
  paymentCancel: "/payment/cancel",
} as const;

export type PublicRouteKey = keyof typeof RouteConstants;

export const PublicRouteOrder = [
  RouteConstants.home,
  RouteConstants.services,
  RouteConstants.packages,
  RouteConstants.portfolio,
  RouteConstants.about,
  RouteConstants.contact,
  RouteConstants.booking,
] as const;
